// The 1-2-1's recordings page (ClientSpace.dc.html; src/products/mentorship/ClientSpace.jsx), plugged into
// the product routes by its file name (src/product/screens.js)
import { ClientSpace } from '../../products/mentorship/ClientSpace.jsx'

export default function MentorshipRecordings(props) {
  return <ClientSpace {...props} page="recordings" />
}
